import { Tooltip } from '@/components/primitives/Tooltip'

import { Row } from '../../Row'

import { useTexts } from '../useTexts'

interface Props {
  count: number
  onSelect: () => void
}

export function OrdersAssigned(props: Props) {
  const { count, onSelect } = props
  const texts = useTexts()

  return (
    <Tooltip
      textAlign="left"
      placement="right"
      title={texts.assigned}
      subtitle={texts.assignedTooltip}
    >
      <Row
        onClick={onSelect}
        text={texts.assigned}
        value={count}
        disabled={count === 0}
        testId="plan-summary-assigned-orders"
      />
    </Tooltip>
  )
}
